import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase/firebaseConfig';
import IdleTimeout from './IdleTimeout';
import './AdminShell.css';

// Stroked SVG icons - sized & coloured via .shell-nav-icon CSS.
const ICONS = {
  dashboard: (
    <svg viewBox="0 0 24 24">
      <rect x="3" y="3"  width="7" height="9" rx="1.5" />
      <rect x="14" y="3" width="7" height="5" rx="1.5" />
      <rect x="14" y="12" width="7" height="9" rx="1.5" />
      <rect x="3" y="16" width="7" height="5" rx="1.5" />
    </svg>
  ),
  members: (
    <svg viewBox="0 0 24 24">
      <circle cx="9" cy="8" r="3.5" />
      <path d="M2.5 20c0-3.5 3-5.5 6.5-5.5s6.5 2 6.5 5.5" />
      <circle cx="17.5" cy="9" r="2.5" />
      <path d="M16 14.5c2.5 0 5 1.5 5 4.5" />
    </svg>
  ),
  addMember: (
    <svg viewBox="0 0 24 24">
      <circle cx="10" cy="8" r="3.5" />
      <path d="M3 20c0-3.5 3-5.5 7-5.5 1.4 0 2.6.25 3.7.7" />
      <path d="M18 14v6" />
      <path d="M15 17h6" />
    </svg>
  ),
  events: (
    <svg viewBox="0 0 24 24">
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M3 10h18" />
      <path d="M8 3v4" />
      <path d="M16 3v4" />
    </svg>
  ),
  addEvent: (
    <svg viewBox="0 0 24 24">
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M3 10h18" />
      <path d="M8 3v4" />
      <path d="M16 3v4" />
      <path d="M12 13v5" />
      <path d="M9.5 15.5h5" />
    </svg>
  ),
  coupons: (
    <svg viewBox="0 0 24 24">
      <path d="M3 9V7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2a2 2 0 0 0 0 4v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2a2 2 0 0 0 0-4Z" />
      <path d="M9 8.5v1" />
      <path d="M9 14.5v1" />
      <path d="M9 11.5v1" />
    </svg>
  ),
  addCoupon: (
    <svg viewBox="0 0 24 24">
      <path d="M3 9V7a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v2a2 2 0 0 0 0 4v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2a2 2 0 0 0 0-4Z" />
      <path d="M19 14v6" />
      <path d="M16 17h6" />
    </svg>
  ),
  notification: (
    <svg viewBox="0 0 24 24">
      <path d="M6 8a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6Z" />
      <path d="M10 20a2 2 0 0 0 4 0" />
    </svg>
  ),
  promo: (
    <svg viewBox="0 0 24 24">
      <path d="M3 13V9a1 1 0 0 1 1-1h4l7-4v14l-7-4H4a1 1 0 0 1-1-1Z" />
      <path d="M17 9.5a3 3 0 0 1 0 5" />
      <path d="M8 14v3a2 2 0 0 0 4 0v-1" />
    </svg>
  ),
  history: (
    <svg viewBox="0 0 24 24">
      <path d="M3.5 12a8.5 8.5 0 1 0 2.6-6.1" />
      <path d="M3 4v4.5h4.5" />
      <path d="M12 7v5l3 2" />
    </svg>
  ),
  logs: (
    <svg viewBox="0 0 24 24">
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="M7 9h10" />
      <path d="M7 13h10" />
      <path d="M7 17h6" />
    </svg>
  ),
  appVersion: (
    <svg viewBox="0 0 24 24">
      <rect x="6" y="2" width="12" height="20" rx="2" />
      <path d="M11 19h2" />
      <path d="M12 9v4" />
      <path d="M9.5 11.5l2.5-2.5 2.5 2.5" />
    </svg>
  ),
  membership: (
    <svg viewBox="0 0 24 24">
      <circle cx="12" cy="9" r="3.5" />
      <path d="M5.5 20c0-3.5 3-5.5 6.5-5.5s6.5 2 6.5 5.5" />
      <path d="M17 4l1.5 1.5L21 3" />
    </svg>
  ),
  pending: (
    <svg viewBox="0 0 24 24">
      <path d="M3 7h18" />
      <path d="M5 7v11a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7" />
      <path d="M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
      <path d="M12 12v3" />
      <circle cx="12" cy="17.5" r="0.7" fill="currentColor" />
    </svg>
  ),
  otp: (
    <svg viewBox="0 0 24 24">
      <rect x="3" y="6" width="18" height="12" rx="2" />
      <path d="M7 10v4" />
      <path d="M12 10v4" />
      <path d="M17 10v4" />
    </svg>
  ),
};

// `section` entries render a small uppercase header above the next group.
const NAV_ITEMS = [
  { to: '/dashboard',             icon: ICONS.dashboard,    label: 'Dashboard'         },

  { section: 'Members' },
  { to: '/members',               icon: ICONS.members,      label: 'All Members'       },
  { to: '/members/add',           icon: ICONS.addMember,    label: 'Add Member'        },
  { to: '/membership/pending',    icon: ICONS.pending,      label: 'Pending Applications' },

  { section: 'Events' },
  { to: '/events',                icon: ICONS.events,       label: 'All Events'        },
  { to: '/events/add',            icon: ICONS.addEvent,     label: 'Add Event'         },

  { section: 'Coupons' },
  { to: '/coupons',               icon: ICONS.coupons,      label: 'All Coupons'       },
  { to: '/coupons/add',           icon: ICONS.addCoupon,    label: 'Add Coupon'        },

  { section: 'Notifications' },
  { to: '/notifications/send',    icon: ICONS.notification, label: 'Send Notification' },
  { to: '/promos/send',           icon: ICONS.promo,        label: 'Send Promo Popup'  },
  { to: '/notifications/history', icon: ICONS.history,      label: 'Sent History'      },

  { section: 'Audit' },
  { to: '/logs',                  icon: ICONS.logs,         label: 'Activity Logs'     },

  { section: 'System' },
  { to: '/membership/config',     icon: ICONS.membership,   label: 'Membership Settings' },
  { to: '/otp/config',            icon: ICONS.otp,          label: 'SMS / OTP Settings' },
  { to: '/app-version',           icon: ICONS.appVersion,   label: 'App Version'       },
];

export default function AdminShell() {
  const navigate        = useNavigate();
  const [open, setOpen] = useState(false); // mobile sidebar toggle
  const user            = auth.currentUser;

  const handleSignOut = async () => {
    await signOut(auth);
    navigate('/login', { replace: true });
  };

  return (
    <div className="shell">
      <IdleTimeout />
      {open && <div className="shell-overlay" onClick={() => setOpen(false)} />}

      {/* ── Sidebar ─────────────────────────────────────────── */}
      <aside className={`shell-sidebar ${open ? 'shell-sidebar--open' : ''}`}>
        {/* Brand */}
        <div className="shell-brand">
          <img
            src="/logo.png"
            alt="Team Fronx"
            className="shell-logo-img"
          />
          <div className="shell-brand-text">
            <span className="shell-brand-name">Team Fronx</span>
            <span className="shell-brand-sub">Admin Portal</span>
          </div>
        </div>

        <div className="shell-divider" />

        {/* Navigation */}
        <nav className="shell-nav">
          {NAV_ITEMS.map((item, i) => {
            if (item.section) {
              return (
                <div key={`sec-${i}`} className="shell-nav-section">
                  {item.section}
                </div>
              );
            }
            return (
              <NavLink
                key={item.to}
                to={item.to}
                end
                className={({ isActive }) =>
                  `shell-nav-item ${isActive ? 'shell-nav-item--active' : ''}`
                }
                onClick={() => setOpen(false)}
              >
                <span className="shell-nav-icon">{item.icon}</span>
                <span className="shell-nav-label">{item.label}</span>
              </NavLink>
            );
          })}
        </nav>

        {/* User + sign-out */}
        <div className="shell-footer">
          <div className="shell-divider" />
          {user && (
            <div className="shell-user">
              <img
                src={user.photoURL || '/avatar-placeholder.png'}
                alt={user.displayName}
                className="shell-user-avatar"
              />
              <div className="shell-user-info">
                <span className="shell-user-name">{user.displayName}</span>
                <span className="shell-user-email">{user.email}</span>
              </div>
            </div>
          )}
          <button className="shell-signout-btn" onClick={handleSignOut}>
            Sign Out
          </button>
        </div>
      </aside>

      {/* ── Main area ───────────────────────────────────────── */}
      <div className="shell-main">
        {/* Mobile top bar. Sign-out is repeated here because the sidebar copy is
            only reachable through the drawer, below a 16-item nav list. */}
        <header className="shell-topbar">
          <button
            className="shell-hamburger"
            onClick={() => setOpen(true)}
            aria-label="Open menu"
          >
            ☰
          </button>
          <span className="shell-topbar-title">Team Fronx Admin</span>
          <button
            className="shell-topbar-signout"
            onClick={handleSignOut}
            aria-label="Sign out"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M15 17l5-5-5-5" />
              <path d="M20 12H9" />
              <path d="M12 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6" />
            </svg>
            <span>Sign Out</span>
          </button>
        </header>

        <main className="shell-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
